import type { AccessControlProvider } from "@refinedev/core";
import { Role } from "entities/user/role";
import {
  FULL_ACCESS_ROLES,
  MENU_RESOURCES,
  HIDDEN_RESOURCE_PARENT_MAP,
} from "constants/resources";

const accessControlProvider: AccessControlProvider = {
  can: async ({ resource, action }) => {
    if (!resource) return { can: false };

    const userStr = localStorage.getItem("ichigo_admin_user");
    if (!userStr) return { can: false };

    const user = JSON.parse(userStr);
    const role: Role = user.role;

    // Menu Permissions page: admin only
    if (resource === "role_permissions") {
      return role === "admin"
        ? { can: true }
        : { can: false, reason: "Only admins can manage menu permissions" };
    }

    // Admin: full access to everything
    if (FULL_ACCESS_ROLES.includes(role)) {
      return { can: true };
    }

    // Configurable roles: check stored permissions
    const permStr = localStorage.getItem("ichigo_admin_permissions");
    if (!permStr) return { can: false, reason: "No permissions assigned" };

    let allowedResources: string[];
    try {
      allowedResources = JSON.parse(permStr);
    } catch {
      return { can: false, reason: "Permission error" };
    }

    // Direct match
    if (allowedResources.includes(resource)) {
      return { can: true };
    }

    // Section resources: show if any child is allowed
    const section = MENU_RESOURCES.find(
      (r) => r.key === resource && r.isSection,
    );
    if (section) {
      const hasAllowedChild = MENU_RESOURCES.some(
        (r) => r.parent === section.key && allowedResources.includes(r.key),
      );
      if (hasAllowedChild) return { can: true };
    }

    // Hidden resources inherit from their parent
    const parentResource = HIDDEN_RESOURCE_PARENT_MAP[resource];
    if (parentResource && allowedResources.includes(parentResource)) {
      return { can: true };
    }

    return { can: false, reason: "No access to this resource" };
  },
};

export default accessControlProvider;
